import React from "react";
import styled from "styled-components";
import FieldContainer from "../FieldContainer";
import Checkbox, { CheckboxProps } from "../ui/Checkbox";
import Label from "../ui/Label";

const StyledLabel = styled(Label)`
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 12px;
`;

const LabelText = styled.div`
  font-weight: ${(props) => props.theme.fontWeights.normal};
  font-size: ${(props) => props.theme.fontSizes.sm}px;
`;

interface Props extends CheckboxProps {
  label?: React.ReactNode;
}

const CheckboxField: React.FC<Props> = ({ name, label, ...props }) => (
  <FieldContainer name={name}>
    {({ inputProps, error }) => (
      <StyledLabel htmlFor={name}>
        <Checkbox name={name} hasError={!!error} {...inputProps} {...props} />

        <LabelText>{label}</LabelText>
      </StyledLabel>
    )}
  </FieldContainer>
);

export default CheckboxField;
